import { createSlice } from '@reduxjs/toolkit';

const initialKurbanReportState = {
    listLoading: false,
    actionsLoading: false,
    totalCount: 0,
    entities: null,
    kurbanReportForEdit: {
        after_photo_uuid: null,
        before_photo_uuid: null,
        created_at: "",
        donation_item: [],
        file_report: false,
        is_merging: null,
        kurban_hid: "",
        organization_uuid: "",
        status: "",
        thk_area: {},
        thk_area_uuid: "",
        thk_kurban_comment: [],
        thk_kurban_log: [],
        thk_livestock: {},
        thk_livestock_uuid: "",
        thk_partner: {},
        thk_partner_uuid: "",
        thk_period_uuid: "",
        updated_at: "",
        uuid: "",
        distributed_city: "",
        distributed_province: "",
        distributed_district: "",
        distributed_address: "",
        distributed_postal_code: "",
        after_photo: {},
        before_photo: {},
    },
    lastError: null,
};

export const callTypes = {
    list: 'list',
    action: 'action',
};

export const kurbanReportSlice = createSlice({
    name: 'kurbanReport',
    initialState: initialKurbanReportState,
    reducers: {
        catchError: (state, action) => {
            state.error = `${action.type}: ${action.payload.error}`;
            if (action.payload.callType === callTypes.list) {
                state.listLoading = false;
            } else {
                state.actionsLoading = false;
            }
        },
        startCall: (state, action) => {
            state.error = null;
            if (action.payload.callType === callTypes.list) {
                state.listLoading = true;
                state.actionsLoading = false;
            } else {
                state.listLoading = false;
                state.actionsLoading = true;
            }
        },

        // getKurbanReportById
        kurbanReportFetched: (state, action) => {
            state.actionsLoading = false;
            state.error = null;
            state.kurbanReportForEdit = action.payload.kurbanReportForEdit;
        },
        // findKurbanReport
        kurbanReportsFetched: (state, action) => {
            const { total_items, items } = action.payload;
            state.listLoading = false;
            state.error = null;
            state.entities = items;
            state.totalCount = total_items;
            state.kurbanReportForEdit = {
                after_photo_uuid: null,
                before_photo_uuid: null,
                created_at: "",
                donation_item: [],
                file_report: false,
                is_merging: null,
                kurban_hid: "",
                organization_uuid: "",
                status: "",
                thk_area: {},
                thk_area_uuid: "",
                thk_kurban_comment: [],
                thk_kurban_log: [],
                thk_livestock: {},
                thk_livestock_uuid: "",
                thk_partner: {},
                thk_partner_uuid: "",
                thk_period_uuid: "",
                updated_at: "",
                uuid: "",
                distributed_city: "",
                distributed_province: "",
                distributed_district: "",
                distributed_address: "",
                distributed_postal_code: "",
                after_photo: {},
                before_photo: {},
            }
        },
        // Set to default state actionLoading & error
        kurbanReportReload: (state, action) => {
            state.actionsLoading = false;
            state.listLoading = false;
            state.error = null;
        },

    },
});

